import React from 'react';
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom';
import Header from '../../components/header/header';
import Footer from '../../components/statics/footer';
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Table,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
} from 'reactstrap';
import classnames from 'classnames';

import './consults.css';
import { timestampToDate, timestampHour } from '../../components/utils/formatTime';

const tabs = {
    requested: 1,
    reserved: 2,
    professionalReserved: 3,
    canceled: 4,
}

class ConsultsScreen extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            activeTab: tabs.requested,
            requestedConsults: [],
            reservedConsults: [],
            professionalReservedConsults: [],
            toCancel: null,
            timeMessage: '',
            paymentMessage: '',
            redirectToPayment: false,
            redirectToChat: false,
        }
    }

    componentDidMount() {
        //console.log('mount ', this.props.user);
        
        //this.loadLists();
    }

    loadLists = () => {
        this.loadRequested();
        this.loadReserved();
        if(this.props.user.is_professional){
            this.loadProfessionalReserved();
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.user.isLoaded !== this.props.user.isLoaded) {
            console.log('update ', prevProps.user);
            this.loadProfessionalReserved();
        }
    }

    /* loadRequested = async () => {
        const result = await getRequestedConsults(this.props.uid);
        if(result.error) {
            //show message
            return;
        }
        this.setState({requestedConsults: result.result.docs});
    }

    loadReserved = async () => {
        const result = await getReservedConsults(this.props.uid);
        if(result.error) {
            //show message
            return;
        }
        this.setState({reservedConsults: result.result.docs});
    }

    loadProfessionalReserved = async () => {
        const result = await getProfessionalReservedConsults(this.props.uid);
        if(result.error) {
            //show message
            return;
        }
        this.setState({professionalReservedConsults: result.result.docs});
    }

    doCancel = async () => {
        console.log(this.state.toCancel);
        const result = cancelConsult(this.state.toCancel);
        if(result.error){
            //error message
            return;
        }
        this.loadLists();
        this.setState({toCancel: null});
    } */

    changeTab(tab) {
        this.setState({activeTab:tab});
    }

    beginConsult = (consult) => {
        //verify if should begin
        const date = consult.appointment_time.toDate();
        const now = new Date();
        const difference = date.getTime() - now.getTime();
        //console.log(difference);
        const enabledTime = 10*60*1000;
        //console.log(enabledTime);
        if(difference > enabledTime) {
            console.log('Retorne quando faltar pelo menos 10 min para a hora agendada');
            return;
        }

        //user has funds to pay
        console.log(this.props.user);
        const duration = consult.estimated_duration / 60;
        const basePrice = duration * consult.price_per_hour;
        console.log(this.props.user.credits);
        
        if(consult.customer == this.props.uid && basePrice > this.props.user.credits) {
            console.log(`Não há créditos suficientes para a consultoria, é necessário pelo menos ${basePrice} créditos para este atedimento`);
            //redirect to payment
            return;
        }

        console.log('begin!');
        //redirect to chat page
    }

    renderTable(docs, isProfessional=false) {
        return (
            <Table responsive>
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Horário</th>
                        <th>Descrição</th>
                        <th>{isProfessional ? 'Cliente' : 'Consultor'}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {docs.map(item => {
                        //console.log(item);
                        const consult = item.data();
                        //console.log(consult);
                        
                        return (
                            <tr key={item.id}>
                                <th scope="row">
                                    {timestampToDate(consult.appointment_time)}
                                </th>
                                <td>
                                    {timestampHour(consult.appointment_time)}
                                </td>
                                <td>
                                    Consultoria de {consult.category}
                                </td>
                                <td>
                                    {isProfessional ? consult.customer_name : consult.professional_name}
                                </td>
                                <td>
                                    {consult.status === 'reserved' ? (
                                        <Button size="sm" color="success" className="mr-2"
                                            onClick={() => this.beginConsult(consult)}
                                        >
                                            Iniciar
                                        </Button>
                                    ) : null}
                                    
                                    <Button size="sm" color="danger"
                                        onClick={() => this.setState({toCancel: item.id})}
                                    >
                                        Cancelar
                                    </Button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        )
    }

    render() {        
        return (
            <div>
                {/* <Header /> */}

                <main className="consults-main">
                    <h2>Minhas consultorias</h2>

                    <div className="main-card">
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                className={classnames({ active: this.state.activeTab === tabs.requested })}
                                onClick={() => this.changeTab(tabs.requested)}
                                >
                                    Solicitadas
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                className={classnames({ active: this.state.activeTab === tabs.reserved })}
                                onClick={() => this.changeTab(tabs.reserved)}
                                >
                                    Agendadas como cliente
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                className={classnames({ active: this.state.activeTab === tabs.professionalReserved })}
                                onClick={() => this.changeTab(tabs.professionalReserved)}
                                >
                                    Agendadas como profissional
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId={tabs.requested}>
                                {this.renderTable(this.state.requestedConsults)}
                            </TabPane>
                            <TabPane tabId={tabs.reserved}>
                                {this.renderTable(this.state.reservedConsults)}
                            </TabPane>
                            {this.props.user.is_professional ? (
                                <TabPane tabId={tabs.professionalReserved}>
                                    {this.renderTable(this.state.professionalReservedConsults, true)}
                                </TabPane>
                            ) : null}
                        </TabContent>
                    </div>

                </main>

                <Footer />

                <Modal isOpen={this.state.toCancel !== null} toggle={() => this.setState({toCancel: null})}>
                    <ModalHeader>
                        Deseja realmente cancelar esta consulta?
                    </ModalHeader>
                    <ModalBody className="d-flex justify-content-around">
                        <Button color="danger" size="sm" onClick={this.doCancel}>
                            Cancelar consulta
                        </Button>
                        <Button outline color="info" size="sm" onClick={() => this.setState({toCancel: null})}>
                            Manter consulta
                        </Button>
                    </ModalBody>

                </Modal>
            </div>
        )
    }
}

//export default ConsultsScreen;

const mapStateToProps = (state)=>{
    return {
        uid: state.firebase.auth.uid,
        auth: state.firebase.auth,
        user: state.firebase.profile,
    }
}
export default connect(mapStateToProps)(ConsultsScreen)
